import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./Contributor.module.scss";
import type { SanityImageObject } from "@sanity/image-url";
import { ResponsiveImage } from "../../../shared/responsiveimage";
export type ContributorType = {
  _id: string;
  image: SanityImageObject;
  displayImage?: boolean;
  name: string;
  first_name?: string; // Optional first name for display purposes
  email?: string;
  subrole?: string;
  additional?: string;
};

/*
 * Column width of the auto-fill grid in Contributors: minmax(240px, 1fr) with a 40px gap above
 * 1180px, minmax(160px, 1fr) with a 20px gap below, in a 90vw (max 1714px) section. One entry per
 * column count; thresholds are rounded up so the wider column is assumed at each boundary.
 */
const CONTRIBUTORS_LIST_SIZES = ["(min-width: 1920px) 253px", "(min-width: 1823px) calc(15vw - 33px)", "(min-width: 1512px) calc(18vw - 32px)", "(min-width: 1200px) calc(22.5vw - 30px)", "(min-width: 1181px) calc(30vw - 26px)", "(min-width: 1178px) calc(15vw - 16px)", "(min-width: 978px) calc(18vw - 16px)", "(min-width: 778px) calc(22.5vw - 15px)", "(min-width: 578px) calc(30vw - 13px)", "(min-width: 378px) calc(45vw - 10px)", "90vw"].join(", ");
export const Contributor: React.FC<ContributorType & {
  contactLink?: boolean;
  locale?: string;
  sizes?: string;
}> = t0 => {
  const $ = _c(22);
  const {
    image,
    displayImage: t1,
    name,
    first_name,
    email,
    subrole,
    additional,
    contactLink: t2,
    locale: t3,
    sizes: t4
  } = t0;
  const displayImage = t1 === undefined ? true : t1;
  const contactLink = t2 === undefined ? false : t2;
  const locale = t3 === undefined ? "no" : t3;
  const sizes = t4 === undefined ? CONTRIBUTORS_LIST_SIZES : t4;
  let contactString;
  if (locale === "no") {
    contactString = "Ta kontakt med";
  } else {
    if (locale === "dk") {
      contactString = "Tag kontakt med";
    } else {
      if (locale === "sv") {
        contactString = "Ta kontakt med";
      } else {
        contactString = "Contact ";
      }
    }
  }
  let t5;
  if ($[0] !== displayImage || $[1] !== image || $[2] !== sizes) {
    t5 = image != null && displayImage && <div className={styles.contributor__image}><ResponsiveImage layout="cover" image={image} coverAspectRatio={0.7741935483870968} sizes={sizes} /></div>;
    $[0] = displayImage;
    $[1] = image;
    $[2] = sizes;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== name) {
    t6 = <span className={styles.contributor__title}>{name}</span>;
    $[4] = name;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = subrole ?? "";
  let t8;
  if ($[6] !== t7) {
    t8 = <span className={styles.contributor__subrole + " detailheader"}>{t7}</span>;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = additional ?? "";
  let t10;
  if ($[8] !== t9) {
    t10 = <span className={styles.contributor__additional + " detailheader"}>{t9}</span>;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== contactLink || $[11] !== contactString || $[12] !== email || $[13] !== first_name || $[14] !== name) {
    t11 = contactLink ? <a href={`mailto:${email}`}><span className={styles.contributor__email + " caption"}>→ {contactString}<span className={styles.contributor__email_name}>{" "}{first_name ? first_name : name.split(" ")[0]}</span></span></a> : <span className={styles.contributor__email + " caption"}>{email ?? ""}</span>;
    $[10] = contactLink;
    $[11] = contactString;
    $[12] = email;
    $[13] = first_name;
    $[14] = name;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t11 || $[18] !== t5 || $[19] !== t6 || $[20] !== t8) {
    t12 = <div className={styles.contributor}>{t5}{t6}{t8}{t10}{t11}</div>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t5;
    $[19] = t6;
    $[20] = t8;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
};